export const ALLOW_PROFILE_IMAGE_UPLOAD = true;

export const PAYIN_AMOUNT_OPTIONS = [
  {
    value: "custom",
    label: "Custom"
  },
  {
    value: "20",
    label: "20"
  },
  {
    value: "100",
    label: "100"
  },
  {
    value: "200",
    label: "200"
  },
  {
    value: "400",
    label: "400"
  }
];

export const PAYOUT_AMOUNT_OPTIONS = [
  {
    value: "custom",
    label: "Custom"
  },
  {
    value: "25",
    label: "25"
  },
  {
    value: "50",
    label: "50"
  },
  {
    value: "75",
    label: "75"
  },
  {
    value: "100",
    label: "100"
  }
];

export const INTELLIGENCE_PRICE_MODEL = "INTELLIGENCE_MONTHLY"; // Professional
export const INTELLIGENCE_DEV_PRICE_MODEL = "INTELLIGENCE_DEV_MONTHLY"; // Developer
export const INTELLIGENCE_BASIC_PRICE_MODEL = "BASIC";
